import script from "./InvestmentsInAssociates.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestmentsInAssociates.vue?vue&type=script&setup=true&lang=js"

import "./InvestmentsInAssociates.vue?vue&type=style&index=0&id=66320a19&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66320a19"]])

export default __exports__